var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swatches"},[_vm._l((_vm.swatches),function(swatch){return [_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({
        placement: 'top',
        theme: 'dark',
        interactive: false,
        boundary: 'window',
      }),expression:"{\n        placement: 'top',\n        theme: 'dark',\n        interactive: false,\n        boundary: 'window',\n      }"}],key:swatch.name + swatch.value,staticClass:"swatch",class:{active: swatch.value === _vm.value},style:({'--currentValue': swatch.value}),attrs:{"content":swatch.name},on:{"click":function($event){return _vm.emit(swatch)}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }